<template>
  <div style="min-height: 100vh">
    <v-card
      flat
      style="background: rgb(237, 237, 237) !important; height: 100vh"
      v-resize="onResize"
    >
      <div v-if="windowSize.x < 1300">
        <v-card
          :loading="loading"
          class="mx-auto"
          max-width="100%"
          style="padding: 0 !important; height: 100vh"
          :elevation="10"
        >
          <v-card-text style="padding: 0px !important">
            <v-row>
              <b-modal
                id="dc-modal"
                centered
                header-bg-variant="danger"
                header-text-variant="light"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
              >
                <template v-slot:modal-header>
                  <h5>{{ t("Alerta") }}</h5>
                </template>

                <pre class="my-3">Perdemos a conexão com o servidor</pre>

                <template v-slot:modal-footer="{ ok }">
                  <b-button variant="light" @click="ok()">OK</b-button>
                </template>
              </b-modal>
              <v-col
                cols="3"
                sm="4"
                md="4"
                lg="4"
                xl="3"
                style="padding-right: 0; padding-top: 0"
              >
                <div style="background: #ef6c00">
                  <v-btn icon :to="'main'">
                    <v-icon color="#fff">mdi-keyboard-backspace</v-icon>
                  </v-btn>
                </div>

                <listaClientes></listaClientes>
              </v-col>
              <v-col
                cols="9"
                sm="8"
                md="8"
                lg="8"
                xl="9"
                style="padding-left: 0"
              >
                <Cliente
                  v-if="conectado && cliente && cliente !== null"
                ></Cliente>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <div v-if="windowSize.x >= 1300">
        <v-toolbar color="primary" dark extended flat>
          <v-btn icon :to="'main'">
            <v-icon>mdi-keyboard-backspace</v-icon>
          </v-btn>
          <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
        </v-toolbar>

        <v-container fluid style="max-width: 80%">
          <v-card
            :loading="loading"
            class="mx-auto"
            max-width="100%"
            style="margin-top: -64px; padding: 0 !important; max-height: 90vh"
            :elevation="10"
          >
            <v-card-text style="padding: 0px !important">
              <v-row>
                <b-modal
                  id="dc-modal"
                  centered
                  header-bg-variant="danger"
                  header-text-variant="light"
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                >
                  <template v-slot:modal-header>
                    <h5>{{ t("Alerta") }}</h5>
                  </template>

                  <pre class="my-3">Perdemos a conexão com o servidor</pre>

                  <template v-slot:modal-footer="{ ok }">
                    <b-button variant="light" @click="ok()">OK</b-button>
                  </template>
                </b-modal>
                <v-col
                  cols="3"
                  sm="4"
                  md="4"
                  lg="4"
                  xl="3"
                  style="padding-right: 0; padding-top: 0"
                >
                  <listaClientes></listaClientes>
                </v-col>
                <v-col
                  cols="9"
                  sm="8"
                  md="8"
                  lg="8"
                  xl="9"
                  style="padding-left: 0"
                >
                  <Cliente
                    v-if="conectado && cliente && cliente !== null"
                  ></Cliente>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
      </div>
    </v-card>
  </div>
</template>
   
<script>
import Cliente from "./Cliente";
import listaClientes from "./ListaClientes";
import { mapActions } from "vuex";
import { mapState } from "vuex";

export default {
  name: "Clientes",
  components: {
    Cliente,
    listaClientes,
  },
  data() {
    return {
      windowSize: {
        x: 0,
        y: 0,
      },
      drawer: true,
      items: [
        { title: "Home", icon: "mdi-home-city" },
        { title: "My Account", icon: "mdi-account" },
        { title: "Users", icon: "mdi-account-group-outline" },
      ],
      mini: true,
      valid: false,
      e1: false,
      password: "",
      passwordRules: [(v) => !!v || "Password is required"],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        // (v) => /^\w+([\\.-]?\\w+)*@\w+([\.-]?\w+)*(\\.\\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
    };
  },
  computed: {
    ...mapState("auth", {
      token: (state) => state.token,
      status: (state) => state.status,
    }),
    ...mapState("xc", {
      conectado: (state) => state.conectado,
      loading: (state) => state.loading,
      atendimento: (state) => state.atendimento,
      cliente: (state) => state.cliente,
    }),
  },
  created() {
    this.getLocalStorage();
    this.getClientes();
  },
  methods: {
    ...mapActions("xc", ["getAtendimentos", "getClientes"]),
    ...mapActions("auth", ["getLocalStorage"]),
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
  watch: {
    conectado(nw) {
      if (!nw) {
        this.$bvModal.show("dc-modal");
      } else {
        this.$bvModal.hide("dc-modal");
      }
    },
  },
};
</script>

<style>
</style>